import { AxiosInstance } from "axios";
import ViaCepService from "../api/ViaCep.service";
import TradeService from "../api/Trade.service";
import { CommonDomainService } from "../api/CommonDomain.service";
import PricingService from "../api/Pricing.service";
import PrecatorioService from "../api/Precatorio.service";
import QuoteService from "../api/Quote.service";
import UserService from "../api/User.service";
import { UserAuthService } from "../api/UserAuth.service";
import DocumentService from "../api/Document.service";
import TradePhaseService from "../api/TradePhase.service";
import QuotePricingService from "../api/QuotePricing.service";
import PendencyService from "../api/Pendency.service";
import SpecialProjectCommissionService from "../api/SpecialProjectCommission.service";
import CredDefenseService from "../api/CredDefense.service";
import FileService from "../api/File.service";
import TradeSearchService from "../api/TradeSearch.service";
import { BCheckService } from "../api/BCheck.service";
import CourtService from "../api/Court.service";
import CourtTypeService from "../api/CourtType.service";
import CourtTypeAccrualTypeService from "../api/CourtTypeAccrualType.service";
import NatureTypeService from "../api/NatureType.service";
import FraudService from "../api/Fraud.service";
import { ExpenseSearchService } from "../api/ExpenseSearch.service";
import { ExpenseRequestService } from "../api/ExpenseRequest.service";
import { ExpenseCommentService } from "../api/ExpenseComment.service";
import { BankDataService } from "../api/BankData.service";
import OfficerService from "../api/Officer.service";
import ExceedMaxPriceBalanceService from "../api/ExceedMaxPriceBalance.service";
import { ReportService } from "../api/Report.service";
import PrePrecatorioService from "../api/PrePrecatorio.service";

export default class ServiceApi {
  public restClient: AxiosInstance;
  public viaCepService: ViaCepService;
  public bCheckService: BCheckService;
  public documentService: DocumentService;
  public tradeService: TradeService;
  public commonDomainService: CommonDomainService;
  public pricingService: PricingService;
  public precatorioService: PrecatorioService;
  public quoteService: QuoteService;
  public userService: UserService;
  public userAuthService: UserAuthService;
  public tradePhaseService: TradePhaseService;
  public quotePricingService: QuotePricingService;
  public pendencyService: PendencyService;
  public specialProjectCommissionService: SpecialProjectCommissionService;
  public credDefenseService: CredDefenseService;
  public fileService: FileService;
  public tradeSearchService: TradeSearchService;
  public courtService: CourtService;
  public NatureTypeService: NatureTypeService;
  public courtTypeService: CourtTypeService;
  public courtTypeAccrualTypeService: CourtTypeAccrualTypeService;
  public fraudService: FraudService;
  public expenseSearchService: ExpenseSearchService;
  public expenseRequestService: ExpenseRequestService;
  public expenseCommentService: ExpenseCommentService;
  public bankDataService: BankDataService;
  public officerService: OfficerService;
  public exceedMaxPriceBalanceService: ExceedMaxPriceBalanceService;
  public reportService: ReportService;
  public prePrecatorioService: PrePrecatorioService;

  constructor(restClient: AxiosInstance) {
    this.restClient = restClient;
    this.viaCepService = new ViaCepService();
    this.bCheckService = new BCheckService(this.restClient);
    this.documentService = new DocumentService(this.restClient);
    this.tradeService = new TradeService(this.restClient);
    this.commonDomainService = new CommonDomainService(this.restClient);
    this.pricingService = new PricingService(this.restClient);
    this.precatorioService = new PrecatorioService(this.restClient);
    this.quoteService = new QuoteService(this.restClient);
    this.userService = new UserService(this.restClient);
    this.userAuthService = new UserAuthService(this.restClient);
    this.tradePhaseService = new TradePhaseService(this.restClient);
    this.quotePricingService = new QuotePricingService(this.restClient);
    this.pendencyService = new PendencyService(this.restClient);
    this.specialProjectCommissionService = new SpecialProjectCommissionService(this.restClient);
    this.credDefenseService = new CredDefenseService(this.restClient);
    this.fileService = new FileService(this.restClient);
    this.tradeSearchService = new TradeSearchService(this.restClient);
    this.courtService = new CourtService(this.restClient);
    this.courtTypeService = new CourtTypeService(this.restClient);
    this.courtTypeAccrualTypeService = new CourtTypeAccrualTypeService(this.restClient);
    this.NatureTypeService = new NatureTypeService(this.restClient);
    this.fraudService = new FraudService(this.restClient);
    this.expenseSearchService = new ExpenseSearchService(this.restClient);
    this.expenseRequestService = new ExpenseRequestService(this.restClient);
    this.expenseCommentService = new ExpenseCommentService(this.restClient);
    this.bankDataService = new BankDataService(this.restClient);
    this.officerService = new OfficerService(this.restClient);
    this.exceedMaxPriceBalanceService = new ExceedMaxPriceBalanceService(this.restClient);
    this.reportService = new ReportService(this.restClient);
    this.prePrecatorioService = new PrePrecatorioService(this.restClient);
  }
}



// WEBPACK FOOTER //
// ./src/services/models/ServiceApi.model.ts